(() => {
  // Reduces ragged flex-wrap gaps by promoting the NEAREST later chip
  // that fits the remaining row space (first-fit with look-ahead).
  // Constraints: the first chip never moves; promotions pick the
  // closest candidate so chips travel as few positions as possible.
  // Applied via CSS `order` so DOM (and tab) order stays curated.
  const pack = (container) => {
    const chips = Array.from(container.children);
    if (chips.length < 3) return;

    const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
    const containerWidth = container.clientWidth;
    const remaining = chips.map((el) => ({ el, w: el.getBoundingClientRect().width }));
    const placed = [];
    let space = containerWidth;
    let rowStart = true;

    while (remaining.length) {
      let pick = -1;
      for (let k = 0; k < remaining.length; k++) {
        const need = rowStart ? remaining[k].w : remaining[k].w + gap;
        if (need <= space + 0.5) {
          pick = k;
          break;
        }
      }
      if (pick === -1) {
        if (rowStart) {
          // Chip wider than the container: place it anyway.
          pick = 0;
        } else {
          // Nothing fits this row; start a new one.
          space = containerWidth;
          rowStart = true;
          continue;
        }
      }
      const [item] = remaining.splice(pick, 1);
      space -= rowStart ? item.w : item.w + gap;
      rowStart = false;
      placed.push(item);
    }

    placed.forEach((item, position) => {
      item.el.style.order = position;
    });
  };

  const packAll = () => {
    document.querySelectorAll('.refinement-chips').forEach(pack);
  };

  let resizeTimer;
  const onResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(packAll, 300);
  };

  const init = () => {
    if (!document.querySelector('.refinement-chips')) return;
    packAll();
    // Re-run once real font metrics are in (widths can change).
    if (document.fonts?.ready) document.fonts.ready.then(packAll);
    window.addEventListener('resize', onResize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
